import { graphqlClient } from '@/lib/graphql-client';

/** What every Data Gateway insert / update / delete returns. */
interface GatewayWriteResult {
  acknowledged?: boolean;
  message?: string | null;
}

/**
 * `graphqlClient.mutate` that also fails when the gateway did not apply the write. A refused write (an
 * access policy, a schema validation, ...) comes back as an ordinary response with `acknowledged: false`
 * and the reason in `message`, so without this check it would be reported as saved.
 */
export const mutateGateway = async <T = Record<string, unknown>>(request: {
  query: string;
  variables?: Record<string, unknown>;
}): Promise<T> => {
  const result = await graphqlClient.mutate<T>(request);
  Object.values((result ?? {}) as Record<string, GatewayWriteResult | null>).forEach((write) => {
    if (write?.acknowledged === false) throw new Error(write.message || 'SOMETHING_WENT_WRONG');
  });
  return result;
};
